<div class="fixedValue"
  >{{ '固定值' }} : <span [ngClass]="{ hasEerror: config.dataValue !== config.fixedValue }">{{ config.fixedValue }}</span>
</div>
